import { point, points } from '@turf/helpers'
import distance from '@turf/distance'
import center from '@turf/center'

// adds google maps script
export const storeLocator = () => {
  const existing = document.querySelector(
    'head script[src*="maps.googleapis.com/maps/"]',
  )
  const map = document.getElementById('map')

  if (existing || !map) return

  const script = document.createElement('script')
  script.setAttribute(
    'src',
    'https://maps.googleapis.com/maps/api/js?key=AIzaSyDJx2oMeE5OsIgjO7uNKnqENqvXrd39sxw&callback=initMap&libraries=&v=weekly',
  )
  document.querySelector('head').appendChild(script)

  const viewButtons = Array.from(
    document.querySelectorAll('.store-locator__tabs button'),
  )
  const views = Array.from(
    document.querySelectorAll('.store-locator__options > div'),
  )

  viewButtons.forEach((item, index) => {
    item.addEventListener('click', () => {
      viewButtons.forEach((view) => view.classList.remove('active'))
      viewButtons[index].classList.add('active')

      views.forEach((view) => view.classList.remove('active'))
      views[index].classList.add('active')
    })
  })
}

export const initMap = () => {
  const defaultPosition = { lat: 39.5, lng: -98.35 }

  // create map object
  const map = new google.maps.Map(document.getElementById('map'), {
    zoom: 4,
    center: defaultPosition,
    mapTypeId: 'roadmap',
    mapTypeControl: false,
    scrollwheel: false,
    streetViewControl: false,
  })

  if (data) {
    const mapData = JSON.parse(data)

    // init marker array
    window.markers = []

    const form = document.getElementById('map-search')
    let geolocation = null

    if (navigator.geolocation) {
      const instructions = document.querySelector(
        '.store-locator__map-container p',
      )

      if (instructions) {
        instructions.textContent =
          'Click the button to get your current location or enter your Zipcode to begin searching.'
      }

      const zipContainer = form.querySelector('label:first-child')
      const locationButton = document.createElement('button')
      locationButton.type = 'button'
      locationButton.innerHTML = '<span></span>Use Current Location'
      locationButton.classList.add('get-location')

      zipContainer.append(locationButton)

      locationButton.addEventListener('click', () => {
        locationButton.classList.add('loading')

        const zipField = document.querySelector('#map-search input[name="zip"]')

        const revealPosition = (position) => {
          geolocation = position.coords
          zipField.value = ''
          locationButton.classList.remove('loading')
          searchStoresByLocation(position.coords, mapData, map, form)
        }

        const geoSettings = {
          enableHighAccuracy: false,
          maximumAge: 30000,
          timeout: 20000,
        }

        navigator.permissions
          .query({ name: 'geolocation' })
          .then(function (result) {
            if (result.state == 'granted') {
              navigator.geolocation.getCurrentPosition(
                revealPosition,
                () => {
                  console.error(
                    'failed to retrieve user location (getCurrentPosition error)',
                  )
                  locationButton.classList.remove('loading')
                },
                geoSettings,
              )
            } else if (result.state == 'prompt') {
              navigator.geolocation.getCurrentPosition(
                revealPosition,
                () => {
                  console.error(
                    'failed to retrieve user location (getCurrentPosition error)',
                  )
                  locationButton.classList.remove('loading')
                },
                geoSettings,
              )
            } else {
              console.error('failed to retrieve user location (API failure)')
              locationButton.classList.remove('loading')
            }
          })
      })
    }

    // form field listeners
    form.addEventListener('submit', (event) => {
      event.preventDefault()
      geolocation = null
      searchStores(event.target, mapData, map)
    })

    document.getElementById('distance').addEventListener('change', () => {
      if (geolocation) {
        searchStoresByLocation(geolocation, mapData, map, form)
      } else {
        searchStores(document.forms['map-search'], mapData, map)
      }
    })
  }
}

function searchStoresByLocation(coords, data, map, form) {
  deleteMarkers()

  const resultsContainer = document.querySelector('.store-locator__results')
  const closeLocations = []
  const formData = new FormData(form)
  const maxDistance = formData.get('distance')
  const lat = coords.latitude
  const lng = coords.longitude

  const from = point([lng, lat])
  const options = { units: 'miles' }

  data.forEach((loc) => {
    const to = point([loc.Longitude, loc.Latitude])
    const d = distance(from, to, options)

    if (d <= parseInt(maxDistance)) {
      loc.distance = d
      closeLocations.push(loc)
    }
  })

  closeLocations.forEach((loc) => {
    const marker = new google.maps.Marker({
      position: {
        lat: parseFloat(loc.Latitude),
        lng: parseFloat(loc.Longitude),
      },
      icon: '/wp-content/themes/allerease/images/marker.svg',
    })

    window.markers.push(marker)
  })

  setMapOnAll(map)

  document
    .querySelector('.store-locator__map-container > p')
    .classList.add('hide')

  resultsContainer.innerHTML = `
    <ul>
      ${closeLocations
        .sort((a, b) => a.distance - b.distance)
        .map((loc) => result(loc))
        .join('')}
    </ul>
  `
}

// get zipcode lat/lng, find close markers, add markers to map
function searchStores(form, data, map) {
  deleteMarkers()

  const resultsContainer = document.querySelector('.store-locator__results')
  const closeLocations = []
  const formData = new FormData(form)
  const zipCode = formData.get('zip')
  const maxDistance = formData.get('distance')
  let lat = null
  let lng = null

  if (zipCode) {
    const geocoder = new google.maps.Geocoder()
    geocoder.geocode({ address: zipCode }, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        lat = results[0].geometry.location.lat()
        lng = results[0].geometry.location.lng()

        // find closest markers
        const from = point([lng, lat])
        const options = { units: 'miles' }

        data.forEach((loc) => {
          const to = point([loc.Longitude, loc.Latitude])
          const d = distance(from, to, options)

          if (d <= parseInt(maxDistance)) {
            loc.distance = d
            closeLocations.push(loc)
          }
        })

        closeLocations.forEach((loc) => {
          const marker = new google.maps.Marker({
            position: {
              lat: parseFloat(loc.Latitude),
              lng: parseFloat(loc.Longitude),
            },
            icon: '/wp-content/themes/allerease/images/marker.svg',
          })

          window.markers.push(marker)
        })

        setMapOnAll(map)

        document
          .querySelector('.store-locator__map-container > p')
          .classList.add('hide')

        resultsContainer.innerHTML = `
          <ul>
            ${closeLocations
              .sort((a, b) => a.distance - b.distance)
              .map((loc) => result(loc))
              .join('')}
          </ul>
        `
      } else {
        console.error('Geocoding has failed')
      }
    })
  } else {
    map.setCenter({ lat: 39.5, lng: -98.35 })
    map.setZoom(4)
    document
      .querySelector('.store-locator__map-container > p')
      .classList.remove('hide')

    resultsContainer.innerHTML = ''
  }
}

// result template
function result(loc) {
  return `
    <li>
      <h4>${loc.LocationName}</h4>
      <p>
        ${Math.round(loc.distance * 100) / 100} miles
      </p>
      <p>
        ${loc.Address1}
        <br/>
        ${loc.City}, ${loc.State_Province} ${loc.Zip_PostalCode}
      </p>
      ${
        loc.ContactPhone
          ? '<p><a href="tel:' +
            loc.ContactPhone.replace(/\W+/gm, '') +
            '">' +
            loc.ContactPhone +
            '</a></p>'
          : ''
      }
    </li>
  `
}

// Sets the map on all markers in the array.
function setMapOnAll(map) {
  const markerList = [...window.markers]

  for (let i = 0; i < window.markers.length; i++) {
    window.markers[i].setMap(map)
  }

  const features = points(
    markerList.map((item) => [item.position.lng(), item.position.lat()]),
  )

  if (features.features.length && map) {
    const centerPoint = center(features)
    map.setCenter({
      lat: centerPoint.geometry.coordinates[1],
      lng: centerPoint.geometry.coordinates[0],
    })
    map.setZoom(8)
  }
}

// Removes the markers from the map.
function deleteMarkers() {
  setMapOnAll(null)
  window.markers = []
}
